import * as analytics from 'analytics/Analytics';
import {
  ActionOrigin,
  ANALYTICS_MODULE,
  ELN_ANALYTICS_ACTIONS,
  REGISTRY_ANALYTICS_ACTIONS,
} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as FileUtil from 'folder-items/FileUtil';
import {getEntryOrFileIdKey} from 'notebook/util/analytics/FileAnalyticsUtils';
import notifications from 'notifications';
import EntityStore from 'stores/EntityStore';
import APIUtil from 'util/APIUtil';
import * as net from 'util/Net';

// TODO(TypeScript): Define types for all link search results
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LinkedItem = any;

/**
 * Track a reference being inserted into a file. Used for analytics and for triggering email notification
 * when a user is mentioned.
 *
 * @param {String} mentioningFileId - API identifier of the file where the mention was inserted
 * @param {String} mentionedId  - API identifier of the entity / file that was mentioned
 * @param {Object} linkedItem - Light-weight server representation of the referenced file
 * @param {ActionOrigin} actionOrigin - Whether a link is being created in a paragraph or table
 */
export default function trackInternalLink(
  mentioningFileId: string,
  mentionedId: string,
  linkedItem: LinkedItem,
  actionOrigin: ActionOrigin
): void {
  if (
    [ModelTypeConstants.ENTITY, ModelTypeConstants.TEAM].includes(APIUtil.apiIdToType(mentionedId)) &&
    !APIUtil.isEntryOrSubOrWorkflowTemplate(mentioningFileId)
  ) {
    net
      .postJSON({
        url: '/1/api/collaboration/actions/insert-at-mention-person',
        data: {
          mentionedId,
          fileId: mentioningFileId,
        },
      })
      .done(({message}) => {
        if (message) {
          notifications.info(message);
        }
      })
      .fail(notifications.notifyError);
    analytics.track('lab_notebook', 'at_mentioned_person', {
      entry_id: mentioningFileId,
      mentioning_entity_id: EntityStore.currentUser().id,
      mentioned_entity_id: mentionedId,
    });
  }
  if (FileUtil.isInRegistry(linkedItem)) {
    analytics.track('bioregistry', 'entry_linked_to_registered_file', {
      fileId: linkedItem.id,
    });
    analytics.deprecatedTrackEvent(REGISTRY_ANALYTICS_ACTIONS.ENTRY_LINKED_TO_FILE, {
      entity_type: APIUtil.apiIdToType(linkedItem.id),
      product: ANALYTICS_MODULE.REGISTRY,
    });
  }
  if (APIUtil.isBatch(mentionedId)) {
    analytics.deprecatedTrackEvent(REGISTRY_ANALYTICS_ACTIONS.ENTRY_LINKED_TO_BATCH, {
      entity_id: mentionedId,
      entry_id: mentioningFileId,
      product: ANALYTICS_MODULE.REGISTRY,
    });
  }
  const fileIdKey = getEntryOrFileIdKey(mentioningFileId);
  analytics.trackEvent(ELN_ANALYTICS_ACTIONS.MENTIONED_OBJECT, {
    action_origin: actionOrigin,
    mentioning_user_id: EntityStore.currentUser().id,
    mentioned_object_id: mentionedId,
    [fileIdKey]: mentioningFileId,
  });
}
